module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"add":"Neu","categories":"Kategorien"},"en":{"add":"Add","categories":"Categories"}}')
  delete Component.options._Ctor
}
